import React from 'react';
import Checkbox from 'antd/lib/checkbox';
var CheckboxWidget = function CheckboxWidget(_ref) {
  var autofocus = _ref.autofocus,
    disabled = _ref.disabled,
    formContext = _ref.formContext,
    id = _ref.id,
    label = _ref.label,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    readonly = _ref.readonly,
    value = _ref.value;
  var _formContext$readonly = formContext.readonlyAsDisabled,
    readonlyAsDisabled = _formContext$readonly === void 0 ? true : _formContext$readonly;
  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    return onChange(target.checked);
  };
  var handleBlur = function handleBlur(_ref3) {
    var target = _ref3.target;
    return onBlur(id, target.checked);
  };
  var handleFocus = function handleFocus(_ref4) {
    var target = _ref4.target;
    return onFocus(id, target.checked);
  };
  return /*#__PURE__*/React.createElement(Checkbox, {
    autoFocus: autofocus,
    checked: typeof value === 'undefined' ? false : value,
    disabled: disabled || readonlyAsDisabled && readonly,
    id: id,
    name: id,
    onBlur: !readonly ? handleBlur : undefined,
    onChange: !readonly ? handleChange : undefined,
    onFocus: !readonly ? handleFocus : undefined
  }, label);
};
export default CheckboxWidget;